import { Text } from "@zapier/design-system";
import { ReactNode } from "react";
import { FloatingClearSelectionButton } from "../FloatingClearSelectionButton";
import styles from "./SelectedItem.module.css";

type Props = {
  label: string;
  icon: ReactNode;
  clearSelection: () => void;
};

export function SelectedItem({ label, icon, clearSelection }: Props) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.col1}>{icon}</div>
      <div className={styles.truncateText}>
        <Text type="SmallPrint2">{label}</Text>
      </div>
      <FloatingClearSelectionButton clearSelection={clearSelection} />
    </div>
  );
}
